// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".raised-card[data-v-6c79a2e9]{padding:1rem;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.1)}.title.is-5[data-v-6c79a2e9]{margin-bottom:.5rem}.subtitle.is-6[data-v-6c79a2e9]{margin-top:-.25rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
